
const store = require('store')
const updateConfiguration=(config)=>{

    store.set('config',config)

    return {
    type:'CONFIG',
    payload:config
}
}

export default updateConfiguration